import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Globe, Check } from "lucide-react";
import { LANGUAGES } from "../i18n";

export default function LanguageMenu() {
  const { i18n, t } = useTranslation();
  const [open, setOpen] = useState(false);
  const current = LANGUAGES.find((l) => l.code === i18n.language) || LANGUAGES[0];
  return (
    <div className="relative" data-testid="lang-switcher">
      <button
        onClick={() => setOpen((s) => !s)}
        className="btn-ghost flex items-center gap-2 text-sm"
        aria-label={t("nav.language")}
      >
        <Globe className="w-4 h-4" />
        <span className="hidden sm:inline">{current.native}</span>
      </button>
      {open && (
        <div className="absolute end-0 mt-2 w-44 rounded-lg border border-white/10 bg-[#0F1116] shadow-2xl py-1 z-50 max-h-[60vh] overflow-y-auto" data-testid="lang-menu">
          {LANGUAGES.map((l) => (
            <button
              key={l.code}
              className="w-full text-start px-3 py-2 text-sm hover:bg-white/5 flex items-center justify-between"
              onClick={() => { i18n.changeLanguage(l.code); setOpen(false); }}
              data-testid={`lang-${l.code}`}
            >
              <span>{l.native}</span>
              {l.code === current.code && <Check className="w-4 h-4 gold-text" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
